function ChartLine(chart, chartDataSelect, chartContainer, dateFrom, dateTo) {
  // ################################################### COLORS #############################################################
  var title = chartContainer.querySelector(".titleContainer > h5");
  var subTitle = chartContainer.querySelector(".titleContainer > h6");
  var legend = chartContainer.querySelector(".legend");
  legend.innerHTML = "";
  legend = legend.appendChild(document.createElement("ul"));
  var additionalInformation = chartContainer.querySelector(
    ".additionalInformation"
  );
  // #########################################################################################################################
  var selected = chartDataSelect.getSelected();

  var weekDayDeals = [0, 0, 0, 0, 0, 0, 0];
  var mostDealsDays = [];

  var datasets = [];
  var labels = [];

  if (selected.PARTNERGROUP) {
    title.innerText = lng.get("dashboard-customers");

    var edges = chartDataSelect.getEdgesFromSelectors();

    var from = moment(dateFrom, "DD.MM.YYYY");
    var to = moment(dateTo, "DD.MM.YYYY");
    var len = parseInt(moment(to).diff(from, "days")) + 1;

    var date = moment(from);
    for (var i = 0; i < len; ++i, date.add(1, "days")) {
      labels.push(date.format("ddd, DD.MM.YYYY"));
    }

    var id;
    var type;
    var typeName;
    if (selected.EMPLOYEE) {
      id = selected.EMPLOYEE;
      type = ChartDataX.EMPLOYEE;
      typeName = lng.get("employee");
    } else if (selected.PARTNER) {
      id = selected.PARTNER;
      type = ChartDataX.PARTNER;
      typeName = lng.get("partner");
    } else {
      id = selected.PARTNERGROUP;
      type = ChartDataX.PARTNERGROUP;
      typeName = lng.get("partnerGroup");
    }
    if (id === ChartDataSelectX.ALL) {
      subTitle.innerText =
        lng.get("dashboard-per") +
        " " +
        typeName +
        " " +
        lng.get("dashboard-per-day");

      var pGpes = chartDataSelect.data.getArrayData(type, edges);

      pGpes.sort(function (a, b) {
        if (a[1] < b[1]) return -1;
        if (b[1] < a[1]) return 1;
        return 0;
      });

      for (let i = 0; i < pGpes.length; ++i) {
        var _Id = pGpes[i][0];
        var name = pGpes[i][1];
        var color = pGpes[i][2];

        var _edges = SetX.intersection(
          chartDataSelect.data.getNameColorEdgesFromId(_Id)[2],
          edges
        );
        var customers = chartDataSelect.data.getArrayData(
          ChartDataX.CUSTOMER,
          _edges
        );

        var data = new Uint32Array(len).fill(0);

        for (var j = 0; j < customers.length; ++j) {
          var customer = moment(customers[j][1]);
          ++weekDayDeals[customer.format("E") - 1];
          ++data[customer.diff(from, "days")];
        }

        datasets.push({
          label: name,
          backgroundColor: color,
          borderColor: color,
          data: data,
          fill: false,
        });

        var legendItem = document.createElement("li");
        var legendItemIcon = document.createElement("i");
        legendItemIcon.setAttribute("class", "material-icons");
        legendItemIcon.style.color = color;
        legendItemIcon.innerText = "fiber_manual_record";
        var legendItemText = document.createElement("span");
        legendItemText.innerText = name + " [" + customers.length + "]";

        legendItem.addEventListener("click", function (e) {
          var hidden = (chart.getDatasetMeta(i).hidden =
            !chart.getDatasetMeta(i).hidden);
          chart.update();
          e.target.parentElement.querySelector("span").style =
            "text-decoration:" + (hidden ? "line-through" : "none") + ";";
        });

        legendItem.appendChild(legendItemIcon);
        legendItem.appendChild(legendItemText);
        legend.appendChild(legendItem);
      }
    } else {
      var dataFromId = chartDataSelect.data.getNameColorEdgesFromId(id);
      var name = dataFromId[0];
      var color = dataFromId[1];
      var _edges = SetX.intersection(dataFromId[2], edges);

      subTitle.innerText =
        lng.get("dashboard-from") +
        " " +
        name +
        " " +
        lng.get("dashboard-per-day");

      var customers = chartDataSelect.data.getArrayData(
        ChartDataX.CUSTOMER,
        _edges
      );

      var data = new Uint32Array(len).fill(0);

      for (var j = 0; j < customers.length; ++j) {
        var customer = moment(customers[j][1]);
        ++weekDayDeals[customer.format("E") - 1];
        ++data[customer.diff(from, "days")];
      }

      datasets.push({
        label: name,
        backgroundColor: color,
        borderColor: color,
        data: data,
        fill: false,
      });

      var legendItem = document.createElement("li");
      var legendItemIcon = document.createElement("i");
      legendItemIcon.setAttribute("class", "material-icons");
      legendItemIcon.style.color = color;
      legendItemIcon.innerText = "fiber_manual_record";
      var legendItemText = document.createElement("span");
      legendItemText.innerText = name + " [" + customers.length + "]";

      legendItem.addEventListener("click", function (e) {
        var hidden = (chart.getDatasetMeta(0).hidden =
          !chart.getDatasetMeta(0).hidden);
        chart.update();
        e.target.parentElement.querySelector("span").style =
          "text-decoration:" + (hidden ? "line-through" : "none") + ";";
      });
      legendItem.appendChild(legendItemIcon);
      legendItem.appendChild(legendItemText);
      legend.appendChild(legendItem);
    }
  } else {
    title.innerText = "";
    subTitle.innerText = "";
  }

  chart.chart.config.data = {
    datasets: datasets,
    labels: labels,
  };

  var most = 0;
  for (var i = 0; i < weekDayDeals.length; ++i) {
    if (most < weekDayDeals[i]) {
      mostDealsDays = [moment.weekdays()[i + 1]];
      most = weekDayDeals[i];
    } else if (0 < most && most === weekDayDeals[i]) {
      mostDealsDays.push(moment.weekdays()[i + 1]);
    }
  }

  var strMostDealDays;
  if (0 < mostDealsDays.length) {
    strMostDealDays =
      mostDealsDays.length > 1
        ? "Wochentag mit den meisten Abschlüssen: "
        : "Wochentag mit den meisten Abschlüssen: ";
    strMostDealDays += mostDealsDays[0] + "s";
    for (var i = 1; i < mostDealsDays.length - 1; ++i) {
      strMostDealDays += ", " + mostDealsDays[i] + "s";
    }
    if (1 < mostDealsDays.length) {
      strMostDealDays +=
        " und " + mostDealsDays[mostDealsDays.length - 1] + "s";
    }

    if (most === 1) {
      strMostDealDays += " mit einem Abschluss";
    } else {
      strMostDealDays += " mit " + most + " Abschlüssen";
    }
  }

  additionalInformation.innerHTML = `<i class="material-icons">timeline</i>
        <span>
            ${
              strMostDealDays
                ? strMostDealDays
                : lng.get("dashboard-no-customers")
            }
        </span>`;
  chart.update();
}
